import { createAction } from '../../utils/redux/createAction';
import { CIRCLE_ACTION_TYPES } from './constants';

export const circleActions = {
  inviteToFamilyCircle: createAction(
    CIRCLE_ACTION_TYPES.INVITE_TO_FAMILY_CIRCLE,
  ),
  changeRole: createAction(CIRCLE_ACTION_TYPES.CHANGE_ROLE),
  removeMember: createAction(CIRCLE_ACTION_TYPES.REMOVE_MEMBER),
  leaveCircle: createAction(CIRCLE_ACTION_TYPES.LEAVE_CIRCLE),
  assignRole: createAction(CIRCLE_ACTION_TYPES.ASSIGN_ROLE),
};



// WEBPACK FOOTER //
// ./src/redux/circles/actions.js